export enum EventType {
  ON_SET = 'ON_SET',
  ON_CHANGE = 'ON_CHANGE',
  ON_DATE = 'ON_DATE'
}

export const EventTypeTranslation = {
  [EventType.ON_SET]: 'Wejście',
  [EventType.ON_CHANGE]: 'Wyjście',
  [EventType.ON_DATE]: 'Po upływie terminu'
};

export const EventTypeList = [
  { value: EventType.ON_SET, text: EventTypeTranslation[EventType.ON_SET] },
  { value: EventType.ON_CHANGE, text: EventTypeTranslation[EventType.ON_CHANGE] },
  { value: EventType.ON_DATE, text: EventTypeTranslation[EventType.ON_DATE] }
];
